module.exports = __webpack_public_path__ + "static/media/no-sig-available.274daa5d.png";